module.exports = __webpack_public_path__ + "img/about_banner.5ca64f4d.b016d1a8.jpg";